module.exports = __webpack_public_path__ + "img/banner-li.5086e735.jpg";